import { Directive, OnDestroy } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { Subscription } from 'rxjs';
import { DeviceDetectorService, BROWSERS } from 'ngx-device-detector';

@Directive({
  selector: 'ag-grid-angular'
})

/**
 * Safari Mobile will not emit the double click event if there are certain CSS styles in use, this
 * directive will attempt to emulate the double click event by subscribing to the click event and
 * keeping track of the time between the clicks. 
 *  
 * https://github.com/ag-grid/ag-grid/issues/2707
 */
export class AgGridMobileDoubleClickDirective implements OnDestroy {
  private readonly doubleClickTime: number = 300; // time in ms

  private onRowClickSubscription: Subscription;
  private lastClickTime: number;
  private lastRowIndex: number;

  constructor(agGrid: AgGridAngular, deviceService: DeviceDetectorService) {
    // only add subsciption if we are on mobile safari, otherwise it will fire the double click twice
    if (deviceService.isDesktop() || deviceService.browser != BROWSERS.SAFARI) return;

    console.log(`AgGridMobileDoubleClickDirective-constructor called`);

    this.onRowClickSubscription = agGrid.rowClicked.subscribe(
      event => {
        const currentTime = (new Date()).getTime();

        console.log(`AgGridMobileDoubleClickDirective-RowClick at ${currentTime}`);

        if (this.lastClickTime && (currentTime - this.lastClickTime) <= this.doubleClickTime && event.rowIndex === this.lastRowIndex) {

            console.log(`AgGridMobileDoubleClickDirective Emulating row double click event`);

          agGrid.rowDoubleClicked.emit(event);
          this.lastClickTime = null;
        } else {
          this.lastClickTime = currentTime;
          this.lastRowIndex = event.rowIndex;
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.onRowClickSubscription)
      this.onRowClickSubscription.unsubscribe();
  }
}


// WEBPACK FOOTER //
// ./src/app/ag-grid-mobile-double-click.directive.ts